<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="internalOfficesTable.additionalFilters"
                                    :default-sort="internalOfficesTable.defaultSort"
                                    :excel="true"
                                    :fields="internalOfficesTable.headers"
                                    :header-selection-key="'internal-offices-headers'"
                                    :height="internalOfficesTable.height"
                                    :total-records="internalOfficesTable.total"
                                    :filter-save-key="'internal-offices-filters'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in internalOfficesTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(props.item.id, true)"
                                    >
                                        <td
                                            v-if="internalOfficesTable.selectedHeaders.includes('id')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td
                                            v-if="internalOfficesTable.selectedHeaders.includes('name')"
                                            class="font-weight-bold"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.name }}
                                        </td>
                                        <td
                                            v-if="internalOfficesTable.selectedHeaders.includes('active')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-icon v-if="item.active" small>fa-check</v-icon>
                                        </td>
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'InternalOffices',
    components: {TheTable},
    data: function () {
        return {
            internalOfficesTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.id'), value: 'id', type: 'string', allowFilter: true},
                    {text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.active'),
                        value: 'active',
                        type: 'boolean',
                        default: null,
                        width: '150px',
                        allowFilter: true,
                    },
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'id',
                    descending: false,
                },
            },
        };
    },
    methods: {
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/internal-offices/' + id);
            } else {
                let routeData = this.$router.resolve('/internal-offices/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.internalOfficesTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall(
                'get',
                'internal-offices',
                request,
                (data, success) => {
                    if (success) {
                        vm.internalOfficesTable.items = data.items;
                        vm.internalOfficesTable.total = data.total;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'internal-offices',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/internal-offices', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.internalOfficesTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.internalOffices'), href: '/#/internal-offices', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
